import { cn } from '../cn';
import { TEXT_VARIANTS, type TextVariant } from '../typography';

import type { ElementType, HTMLAttributes } from 'react';

const DEFAULT_TAG: Record<TextVariant, ElementType> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  'body-lg': 'p',
  'body-sm': 'p',
  'body-micro': 'p',
  'link-lg': 'span',
  'link-sm': 'span',
  mono: 'code',
};

export interface TextProps extends HTMLAttributes<HTMLElement> {
  variant?: TextVariant | undefined;
  /** Override the element, for example `as="span"` for an inline heading style. */
  as?: ElementType | undefined;
  /** `subdued` = secondary text colour. Default inherits. */
  tone?: 'default' | 'subdued' | 'placeholder' | 'inversed' | undefined;
}

const TONE = {
  default: 'text-content-default',
  subdued: 'text-content-subdued',
  placeholder: 'text-content-placeholder',
  inversed: 'text-content-inversed',
} as const;

/** The design-system type scale as a component. Same classes as tokens/typography-scale.css. */
export function Text({ variant = 'body-sm', as, tone, className, ...rest }: TextProps) {
  const Tag = as ?? DEFAULT_TAG[variant];
  return <Tag className={cn(TEXT_VARIANTS[variant], tone && TONE[tone], className)} {...rest} />;
}
